var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://use.fontawesome.com/releases/v5.8.2/css/all.css","integrity":"sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay","crossorigin":"anonymous"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }